import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {
	OktaAuthModule,
	OktaCallbackComponent,
	OKTA_CONFIG
} from '@okta/okta-angular';
import {BrowserModule} from '@angular/platform-browser';
import {AuthenticationService} from './services/authentication.service';
import {AppUserData} from './framework/AppUser';
import {MyOktaAuthGuard} from './my-okta-auth-guard';
import {environment} from '../environments/environment';
//import {OktaCallbackPage} from './OktaCallbackPage';

const routes: Routes = [
	{
		path: 'implicit/callback',
		component: OktaCallbackComponent
	},
	// {
	// 	path: 'login',
	// 	component: OktaLoginRedirectComponent
	// },
	{
		path: 'p',
		canActivate: [MyOktaAuthGuard],
		loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
	},
	{
		path: '**',
		canActivate: [MyOktaAuthGuard],
		loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes), OktaAuthModule, BrowserModule],
	exports: [RouterModule],
	providers: [{provide: OKTA_CONFIG, useValue: environment.okta}, MyOktaAuthGuard, AuthenticationService, AppUserData]
})
export class AppRoutingModule {
}

